
import React from 'react';
import { Form } from '../../../../components/interface/AssessmentInterface';
import CustomButton from '../../../../components/Button/DialogButtons';



interface FormDetailsProps {
    form: Form;
    isstartMode: boolean;
    handleInputChange: (questionId: number, value: any) => void;
    handleBack: () => void;
    handleSave?: () => void;
}

const FormDetails: React.FC<FormDetailsProps> = ({ form, isstartMode, handleInputChange, handleBack, handleSave }) => {
    return (
        <div className="border border-gray-300 shadow-lg rounded-lg p-6 m-4 w-full bg-white">
            <div className='flex justify-between py-2'>
                <h2 className="text-lg font-semibold text-gray-800 underline mb-2">{form.name}</h2>
                {!isstartMode ? (
                    // Optionally render a different button in start mode or keep it empty
                    <CustomButton onClick={handleBack} color="secondary">
                        Back
                    </CustomButton>
                ) : null}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {form.questions.length > 0 ? (
                    form.questions.map((question, index) => (
                        <div key={question.question.id} className="border border-gray-300 p-4 rounded-md shadow-sm">
                            <h3 className="text-base font-medium text-gray-700 mb-2">
                                {index + 1}. {question.question.name}
                            </h3>

                            {!isstartMode ? (
                                question.question.type !== 'sub_question' && question.question.type !== 'input' && (
                                    (() => {
                                        const selectedAnswerId = form.latest_form_submisson?.answers[String(question.question.id)]?.id;

                                        return (
                                            <div className="space-y-2">
                                                {question.answers.map((answer) => {
                                                    const isSelected = selectedAnswerId === answer.answer.id;
                                                    return (
                                                        <p
                                                            key={answer.answer.id}
                                                            className={`p-2 rounded-md ${isSelected ? 'bg-green-100 font-bold text-green-800' : 'text-gray-700'
                                                                }`}
                                                        >
                                                            {answer.answer.name}
                                                        </p>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })()
                                )
                            ) : (
                                question.question.type === 'radio' && (
                                    <div className="space-y-2">
                                        {question.answers.map(answer => (
                                            <label key={answer.answer.id} className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name={`question-${question.question.id}`}
                                                    value={answer.answer.id}
                                                    className="form-radio text-indigo-600 h-4 w-4"
                                                    onChange={(e) => handleInputChange(question.question.id, e.target.value)}
                                                />
                                                <span className="text-gray-700">{answer.answer.name}</span>
                                            </label>
                                        ))}
                                    </div>
                                )
                            )}


                            {question.question.sub_questions && question.question.sub_questions.length > 0 && (
                                <div className="ml-4 space-y-4">
                                    {question.question.sub_questions.map((subQuestion, subIndex) => (
                                        <div key={subQuestion.id}>
                                            <h4 className="text-sm font-semibold text-gray-600">{subIndex + 1}. {subQuestion.name}</h4>

                                            {/* Render answers for sub-questions */}
                                            {!isstartMode ? (
                                                (() => {
                                                    const selectedSubAnswerId = form.latest_form_submisson?.answers[subQuestion.id]?.id;

                                                    return (
                                                        <div className="space-y-2">
                                                            {question.answers.map((answer) => {
                                                                const isSelected = selectedSubAnswerId === answer.answer.id;
                                                                return (
                                                                    <p
                                                                        key={answer.answer.id}
                                                                        className={`p-2 rounded-md ${isSelected ? 'bg-green-100 font-bold text-green-800' : 'text-gray-700'
                                                                            }`}
                                                                    >
                                                                        {answer.answer.name}
                                                                    </p>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                })()
                                            ) : (
                                                question.answers.map(answer => (
                                                    <label key={answer.answer.id} className="flex items-center space-x-2 mt-2">
                                                        <input
                                                            type="radio"
                                                            name={`sub-question-${subQuestion.id}`}
                                                            value={answer.answer.id}
                                                            className="form-radio text-indigo-600 h-4 w-4"
                                                            onChange={(e) => handleInputChange(subQuestion.id, e.target.value)}
                                                        />
                                                        <span className="text-gray-700">{answer.answer.name}</span>
                                                    </label>
                                                ))
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {question.question.type === 'instructions' && question.question.additional_info?.image_url && (
                                <div className="m-4">
                                    <img
                                        src={`https://telegaruda.a2zhealth.in/hospital/assets/media/assessment/${question.question.additional_info.image_url}`}
                                        alt="Instruction"
                                        className="object-fill"
                                    />
                                </div>
                            )}

                            {question.question.type === 'input' && (
                                <p className="text-gray-700 mt-2">
                                    {isstartMode ? (
                                        <input
                                            type="number"
                                            placeholder={question.answers[0]?.answer.name || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.trim() !== '' && !isNaN(Number(value))) {
                                                    handleInputChange(question.question.id, Number(value)); // Convert to number
                                                }
                                            }}
                                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 mt-2"
                                        />
                                    ) : (
                                        <p
                                            className={`p-2 rounded-md ${form.latest_form_submisson?.answers[question.question.id]
                                                    ? 'bg-green-100 font-bold text-green-800'
                                                    : ''
                                                }`}
                                        >
                                            {form.latest_form_submisson?.answers[question.question.id] != null // Check for null/undefined
                                                ? (typeof form.latest_form_submisson.answers[question.question.id] === 'object'
                                                    ? form.latest_form_submisson.answers[question.question.id].name // Render the name property if it's an object
                                                    : form.latest_form_submisson.answers[question.question.id].toString()) // Convert number to string for rendering
                                                : ''}
                                        </p>
                                    )}
                                </p>
                            )}


                        </div>
                    ))
                ) : (
                    <p className="text-gray-700">No questions available.</p>
                )}
            </div>
            <div className="flex justify-center mt-6 space-x-4">
                {isstartMode ? (
                    <CustomButton onClick={handleBack} color="secondary">
                        Cancel
                    </CustomButton>
                ) : (
                    <CustomButton onClick={handleBack} color="secondary">
                        Back
                    </CustomButton>
                )}
                {isstartMode && (
                    <CustomButton onClick={handleSave || (() => { })} color="primary">
                        Save
                    </CustomButton>
                )}
            </div>
        </div>
    );
};

export default FormDetails;
